import React, { useState, useEffect, useContext } from "react";
import { Urls } from "../../../../Urls";
import Axios from "../../../../Axios";
import { toast } from "react-toastify";
import { saveMastersApi } from "../../../CompanyProfileNew/Utility";
import AutoComplete from "../../../Freightrates1/AutoComplete/AutoComplete";
import { useReducer } from "react";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const PlacementDetails = ({
  getEnquiryApis,
  newSpot,
  // truck_enquiry_id="",
  enquiryBucket,
  company_id = "",
  item = "",
  send_data = [],
  // setsenddata='',
  editmode = false,
  planningbutton,
  backbutton,
  discovernowbutton,
  index,
}) => {
  // const [loading_address, setLoading_address] = useState('')
  // const [unloading_address, setUnloading_address] = useState([''])
  // const [additional_details, setAdditional_details] = useState('')
  // const [loading_address_oneway, setLoading_address_oneway] = useState('')

  /**
   * Initializes state for different journey types (One Way, Round Trip, Multi Drop).
   *
   * @returns {Object} State and setter function for the specific journey type.
   */
  const [oneWay, setOneWay] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      loading_address: "",
      loading_location_code: "",
      loading_gst_no: "",
      loading_customer_name: "",
      loading_pincode: "",
      unloading_address: [""],
      unloading_location_code: [""],
      unloading_gst_no: [""],
      unloading_customer_name: [""],
      unloading_pincode: [""],
      additional_details: "",
    }
  );

  const [roundWay, setRoundWay] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      loading_address: "",
      loading_location_code: "",
      loading_gst_no: "",
      loading_customer_name: "",
      loading_pincode: "",
      unloading_address: [""],
      unloading_location_code: [""],
      unloading_gst_no: [""],
      unloading_customer_name: [""],
      unloading_pincode: [""],
      additional_details: "",
    }
  );

  const [multiDrop, setMultiDrop] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      loading_address: "",
      loading_location_code: "",
      loading_gst_no: "",
      loading_customer_name: "",
      loading_pincode: "",
      unloading_address: [""],
      set_unloading_address: [],
      unloading_location: [""],
      unloading_location_code: [""],
      unloading_gst_no: [""],
      unloading_customer_name: [""],
      unloading_pincode: [""],
      additional_details: "",
    }
  );
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [company_profile, setCompany_profile] = useState(false);
  const [noofdestination, setNoofdestination] = useState(1);
  const [drop, setDrop] = useState("");
  const { TrackMixPanel } = useMixPanelForTracking(userDetails,companySettingData);

  const handleEditPlacementDetails = async () => {
  if(company_profile){
    submitdata()
  }
  try {
    if (!drop) {
      toast.error("Please select a trip type before updating.");
      return;
    }
    const uri = `${Urls.spot}?field=edit_enquiry_v2`;
    // console.log(item,"item")
    let payload = {
      truck_enquiry_id: item?.truck_enquiry_id,
      drop: drop,
    };
    if (drop === "oneway") {
      payload = {
        ...payload,
        loading_address: oneWay.loading_address,
        loading_location_code: oneWay.loading_location_code,
        loading_gst_no: oneWay.loading_gst_no,
        loading_customer_name: oneWay.loading_customer_name,
        loading_pincode: oneWay.loading_pincode,
        unloading_address: oneWay.unloading_address,
        unloading_location_code: oneWay.unloading_location_code,
        unloading_gst_no: oneWay.unloading_gst_no,
        unloading_customer_name: oneWay.unloading_customer_name,
        unloading_pincode: oneWay.unloading_pincode,
        additional_details: oneWay.additional_details,
      };
    } 
    else if (drop === "roundtrip") {
      payload = {
        ...payload,
        loading_address: roundWay.loading_address,
        loading_location_code: roundWay.loading_location_code,
        loading_gst_no: roundWay.loading_gst_no,
        loading_customer_name: roundWay.loading_customer_name,
        loading_pincode: roundWay.loading_pincode,
        unloading_address: roundWay.unloading_address,
        unloading_location_code: roundWay.unloading_location_code,
        unloading_gst_no: roundWay.unloading_gst_no,
        unloading_customer_name: roundWay.unloading_customer_name,
        unloading_pincode: roundWay.unloading_pincode,
        additional_details: roundWay.additional_details,
      };
    }
    else if (drop === "multidrop") {
      payload = {
        ...payload,
        loading_address: multiDrop.loading_address,
        loading_location_code: multiDrop.loading_location_code,
        loading_gst_no: multiDrop.loading_gst_no,
        loading_customer_name: multiDrop.loading_customer_name,
        loading_pincode: multiDrop.loading_pincode,
        unloading_address: multiDrop.unloading_address,
        unloading_location_code: multiDrop.unloading_location_code,
        unloading_gst_no: multiDrop.unloading_gst_no,
        unloading_customer_name: multiDrop.unloading_customer_name,
        unloading_pincode: multiDrop.unloading_pincode,
        additional_details: multiDrop.additional_details,
      };
    }

    await Axios.post(uri, payload);
    toast.success("Placement Details Updated.");
    getEnquiryApis()
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong while updating.");
  }
  };
  useEffect(() => {
    if (item.savecompanyprofile) {
      setCompany_profile(true);
    }
  }, [item]);

  /**
   * useEffect to set the state for journey type based on the planning button status and item.drop.
   *
   * @param {Object} item - The item containing drop and other properties.
   * @param {boolean} planningbutton - The status of the planning button.
   */
  useEffect(() => {
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - placement details",
      Data: `lane: ${item.origin.location_name} to ${item.destination.location_name}, truck type : ${item?.truck_types?.[0]?.label}`,
      Definition: `user viewed placement details for an enquiry`,
    });
    if (planningbutton) {
      // When planningbutton is true, set the drop state and style for "One-way"
      setDrop("oneway");
      const onewayButton = document.getElementById("oneway");
      if (onewayButton) {
        onewayButton.style.background = "#e0e0e0";
        onewayButton.style.color = "#54af3a";
      }
    } else {
      // When planningbutton is false, set the drop state as per item.drop
      setDrop(item.drop);
    }

    if (item.drop === "multidrop") {
      setMultiDrop({ loading_address: item.loading_address });
      setMultiDrop({ loading_customer_name: item.loading_customer_name });
      setMultiDrop({ loading_gst_no: item.loading_gst_no });
      setMultiDrop({ loading_location_code: item.loading_location_code });
      setMultiDrop({ loading_pincode: item.loading_pincode });
      setMultiDrop({
        unloading_address:
          item.unloading_address && item.unloading_address.length > 0
            ? item.unloading_address
            : [""],
      });
      setMultiDrop({
        unloading_customer_name:
          item.unloading_customer_name &&
          item.unloading_customer_name.length > 0
            ? item.unloading_customer_name
            : [""],
      });
      setMultiDrop({
        unloading_gst_no:
          item.unloading_gst_no && item.unloading_gst_no.length > 0
            ? item.unloading_gst_no
            : [""],
      });
      setMultiDrop({
        unloading_location_code:
          item.unloading_location_code &&
          item.unloading_location_code.length > 0
            ? item.unloading_location_code
            : [""],
      });
      setMultiDrop({
        unloading_pincode:
          item.unloading_pincode && item.unloading_pincode.length > 0
            ? item.unloading_pincode
            : [""],
      });
      setMultiDrop({
        additional_details: item.additional_details
          ? item.additional_details
          : "",
      });
      setNoofdestination(item.unloading_address.length);
    } else if (item.drop === "oneway") {
      setOneWay({ loading_address: item.loading_address });
      setOneWay({ loading_customer_name: item.loading_customer_name });
      setOneWay({ loading_gst_no: item.loading_gst_no });
      setOneWay({ loading_location_code: item.loading_location_code });
      setOneWay({ loading_pincode: item.loading_pincode });
      setOneWay({
        unloading_address:
          item.unloading_address && item.unloading_address.length > 0
            ? item.unloading_address
            : [""],
      });
      setOneWay({
        unloading_customer_name:
          item.unloading_customer_name &&
          item.unloading_customer_name.length > 0
            ? item.unloading_customer_name
            : [""],
      });
      setOneWay({
        unloading_gst_no:
          item.unloading_gst_no && item.unloading_gst_no.length > 0
            ? item.unloading_gst_no
            : [""],
      });
      setOneWay({
        unloading_location_code:
          item.unloading_location_code &&
          item.unloading_location_code.length > 0
            ? item.unloading_location_code
            : [""],
      });
      setOneWay({
        unloading_pincode:
          item.unloading_pincode && item.unloading_pincode.length > 0
            ? item.unloading_pincode
            : [""],
      });
      setOneWay({
        additional_details: item.additional_details
          ? item.additional_details
          : "",
      });
    } else if (item.drop === "roundtrip") {
      setRoundWay({ loading_address: item.loading_address });
      setRoundWay({ loading_customer_name: item.loading_customer_name });
      setRoundWay({ loading_gst_no: item.loading_gst_no });
      setRoundWay({ loading_location_code: item.loading_location_code });
      setRoundWay({ loading_pincode: item.loading_pincode });
      setRoundWay({
        unloading_address:
          item.unloading_address && item.unloading_address.length > 0
            ? item.unloading_address
            : [""],
      });
      setRoundWay({
        unloading_customer_name:
          item.unloading_customer_name &&
          item.unloading_customer_name.length > 0
            ? item.unloading_customer_name
            : [""],
      });
      setRoundWay({
        unloading_gst_no:
          item.unloading_gst_no && item.unloading_gst_no.length > 0
            ? item.unloading_gst_no
            : [""],
      });
      setRoundWay({
        unloading_location_code:
          item.unloading_location_code &&
          item.unloading_location_code.length > 0
            ? item.unloading_location_code
            : [""],
      });
      setRoundWay({
        unloading_pincode:
          item.unloading_pincode && item.unloading_pincode.length > 0
            ? item.unloading_pincode
            : [""],
      });
      setRoundWay({
        additional_details: item.additional_details
          ? item.additional_details
          : "",
      });
    }
  }, []);

  /**
   * Submits the placement data and handles validation for different drop types (multidrop, oneway, roundtrip).
   *
   * @function submitdata
   * @param {string} drop - The type of drop ('multidrop', 'oneway', or 'roundtrip').
   * @param {Object} multiDrop - The details for multidrop, including loading and unloading addresses, GST numbers, and location codes.
   * @param {Object} oneWay - The details for oneway, including loading and unloading addresses, GST numbers, and location codes.
   * @param {Object} roundWay - The details for roundtrip, including loading and unloading addresses, GST numbers, and location codes.
   * @param {Object} item - The item object that will be updated with drop details.
   * @param {Array} send_data - The array containing all the items to be submitted.
   * @param {boolean} company_profile - Indicates whether to save the details in the company profile.
   * @param {string} company_id - The ID of the company to which the data belongs.
   * @returns {void}
   */
  const submitdata = () => {
    let allFieldsFilled = true;
    let saveInCompanyProfile = true;
    // const sqlPattern = /\b(SELECT\s+\*|INSERT\s+INTO|DELETE\s+FROM|UPDATE\s+\w+|DROP\s+TABLE|ALTER\s+TABLE|TRUNCATE\s+TABLE|EXEC\s+\w+|UNION\s+SELECT)\b|(--|;|'|\/\*|\*\/)/gi;
    const sqlPattern = /.*/gi;
    let hasSqlInjection = false;
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - placement details",
      Data: `lane: ${item && item.origin && item.origin.location_name ? item.origin.location_name : ''} to ${item && item.destination && item.destination.location_name ? item.destination.location_name : ""}, truck type : ${item?.truck_types?.[0]?.label}, drop: ${drop}`,
      Definition: `user submitted placement details for an enquiry`,
    });
    if (drop === "multidrop") {
      var isMultidropEmptyAddress = multiDrop.unloading_address.some(
        (value) => value.trim() === ""
      );
      var isMultidropEmptyCode = multiDrop.unloading_location_code.some(
        (value) => value.trim() === ""
      );
      var isMultidropEmptyGST = multiDrop.unloading_gst_no.some(
        (value) => value.trim() === ""
      );

      // Validate against SQL Pattern in addresses
      // var hasSqlInjection = multiDrop.unloading_address.some(value => sqlPattern.test(value)) ||
      //                       sqlPattern.test(multiDrop.loading_address);

      if (
        multiDrop.unloading_address !== undefined &&
        multiDrop.unloading_address !== null &&
        multiDrop.unloading_address.length > 0 &&
        !isMultidropEmptyAddress &&
        multiDrop.loading_address &&
        multiDrop.loading_address !== null &&
        multiDrop.loading_address !== undefined &&
        multiDrop.loading_address !== "" &&
        !hasSqlInjection // Check for SQL pattern here
      ) {
        item.drop = drop;
        item.loading_address = multiDrop.loading_address;
        item.unloading_address = multiDrop.unloading_address;
        item.additional_details = multiDrop.additional_details;
      } else {
        toast.error("Please enter valid Loading and Unloading Addresses");
        allFieldsFilled = false;
        return null;
      }

      if (isMultidropEmptyCode && company_profile) {
        toast.error("Please enter valid Location Code");
        saveInCompanyProfile = false;
        return null;
      }
      if (isMultidropEmptyGST && company_profile) {
        toast.error("Please enter valid GST Number");
        saveInCompanyProfile = false;
        return null;
      }
    } else if (drop === "oneway") {
      var isOnewayEmpty = oneWay.unloading_address.some(
        (value) => value.trim() === ""
      );
      var isOnewayEmptyCode = oneWay.unloading_location_code.some(
        (value) => value.trim() === ""
      );
      var isOnewayEmptyGST = oneWay.unloading_gst_no.some(
        (value) => value.trim() === ""
      );

      // Validate against SQL Pattern in addresses
      // var hasSqlInjection = oneWay.unloading_address.some(value => sqlPattern.test(value)) ||
      //   sqlPattern.test(oneWay.loading_address);
      if (
        oneWay.unloading_address !== undefined &&
        oneWay.unloading_address !== null &&
        oneWay.unloading_address.length > 0 &&
        !isOnewayEmpty &&
        oneWay.loading_address &&
        oneWay.loading_address !== null &&
        oneWay.loading_address !== undefined &&
        oneWay.loading_address !== "" &&
        !hasSqlInjection // Check for SQL pattern here
      ) {
        item.drop = drop;
        item.loading_address = oneWay.loading_address;
        item.unloading_address = oneWay.unloading_address;
        item.additional_details = oneWay.additional_details;
      } else {
        toast.error("Please enter valid Loading and Unloading Addresses");
        allFieldsFilled = false;
        return null;
      }
      if (isOnewayEmptyCode && company_profile) {
        toast.error("Please enter valid Location Code");
        saveInCompanyProfile = false;
        return null;
      }
      if (isOnewayEmptyGST && company_profile) {
        toast.error("Please enter valid GST Number");
        saveInCompanyProfile = false;
        return null;
      }
    } else if (drop === "roundtrip") {
      var isRoundwayEmpty = roundWay.unloading_address.some(
        (value) => value.trim() === ""
      );
      var isRoundwayEmptyCode = roundWay.unloading_location_code.some(
        (value) => value.trim() === ""
      );
      var isRoundwayEmptyGST = roundWay.unloading_gst_no.some(
        (value) => value.trim() === ""
      );

      // Validate against SQL Pattern in addresses
      // var hasSqlInjection = roundWay.unloading_address.some(value => sqlPattern.test(value)) ||
      //   sqlPattern.test(roundWay.loading_address);

      if (
        roundWay.unloading_address !== undefined &&
        roundWay.unloading_address !== null &&
        roundWay.unloading_address.length > 0 &&
        !isRoundwayEmpty &&
        roundWay.loading_address &&
        roundWay.loading_address !== null &&
        roundWay.loading_address !== undefined &&
        roundWay.loading_address !== "" &&
        !hasSqlInjection // Check for SQL pattern here
      ) {
        item.drop = drop;
        item.loading_address = roundWay.loading_address;
        item.unloading_address = roundWay.unloading_address;
        item.additional_details = roundWay.additional_details;
      } else {
        toast.error("Please enter valid Loading and Unloading Addresses");
        allFieldsFilled = false;
        return null;
      }

      if (isRoundwayEmptyCode && company_profile) {
        toast.error("Please enter valid Location Code");
        saveInCompanyProfile = false;
        return null;
      }
      if (isRoundwayEmptyGST && company_profile) {
        toast.error("Please enter valid GST Number");
        saveInCompanyProfile = false;
        return null;
      }
    }

    if (allFieldsFilled || saveInCompanyProfile) {
      send_data[index] = item;
      toast.success("Placement Details Submitted Successfully!");
    }

    if (
      company_profile &&
      allFieldsFilled &&
      (drop === "oneway" || drop === "roundtrip")
    ) {
      Axios.get(
        `${Urls.companyProfile}?company_id=${company_id}&projections_enable=location_details`
      )
        .then((res) => {
          if (res.data && res.data.length > 0 && res.data[0].location_details) {
            var temp_location_details = res.data[0].location_details.slice();
            // if(send_data && send_data.length > 0){
            //     send_data.map((lane, index) => {
            //         if(index === truck_enquiry_id){
            // var companyprofile = {savecompanyprofile : true}
            item.savecompanyprofile = true;
            if (!item.origin.location_type) {
              temp_location_details.push({
                addressLine1:
                  drop === "oneway"
                    ? oneWay.loading_address
                    : roundWay.loading_address,
                addressLine2: "",
                customer_name:
                  drop === "oneway"
                    ? oneWay.loading_customer_name
                    : roundWay.loading_customer_name,
                gst_no:
                  drop === "oneway"
                    ? oneWay.loading_gst_no
                    : roundWay.loading_gst_no,
                location_code:
                  drop === "oneway"
                    ? oneWay.loading_location_code
                    : roundWay.loading_location_code,
                pincode:
                  drop === "oneway"
                    ? oneWay.loading_pincode
                    : roundWay.loading_pincode,
                location: item.origin,
                type: "Plant",
              });
            }
            if (!item.destination.location_type) {
              // unloading_address.map((address) => {
              temp_location_details.push({
                addressLine1:
                  drop === "oneway"
                    ? oneWay.unloading_address[0]
                    : roundWay.unloading_address[0],
                addressLine2: "",
                customer_name:
                  drop === "oneway"
                    ? oneWay.unloading_customer_name[0]
                    : roundWay.unloading_customer_name[0],
                gst_no:
                  drop === "oneway"
                    ? oneWay.unloading_gst_no[0]
                    : roundWay.unloading_gst_no[0],
                location_code:
                  drop === "oneway"
                    ? oneWay.unloading_location_code[0]
                    : roundWay.unloading_location_code[0],
                pincode:
                  drop === "oneway"
                    ? oneWay.unloading_pincode[0]
                    : roundWay.unloading_pincode[0],
                location: item.destination,
                type: "Destination",
              });
              // })
            }
            saveMastersApi(company_id, "location", temp_location_details, TrackMixPanel)
              .then((res) => {
                // toast.success('Details added in company profile')
              })
              .catch((err) => console.log(err));
          }
        })
        .catch((e) => console.log(e));
    } else if (company_profile && allFieldsFilled && drop === "multidrop") {
      Axios.get(
        `${Urls.companyProfile}?company_id=${company_id}&projections_enable=location_details`
      )
        .then((res) => {
          if (res.data && res.data.length > 0 && res.data[0].location_details) {
            var temp_location_details = res.data[0].location_details.slice();
            item.savecompanyprofile = true;
            if (!item.origin.location_type) {
              temp_location_details.push({
                addressLine1: multiDrop.loading_address,
                addressLine2: "",
                customer_name: multiDrop.loading_customer_name,
                gst_no: multiDrop.loading_gst_no,
                location_code: multiDrop.loading_location_code,
                pincode: multiDrop.loading_pincode,
                location: item.origin,
                type: "Plant",
              });
            }
            multiDrop.set_unloading_address.push(item.destination);
            multiDrop.unloading_address.map((items, index) => {
              if (!item.destination.location_type) {
                temp_location_details.push({
                  addressLine1: items,
                  addressLine2: "",
                  customer_name: multiDrop.unloading_customer_name[index],
                  gst_no: multiDrop.unloading_gst_no[index],
                  location_code: multiDrop.unloading_location_code[index],
                  pincode: multiDrop.unloading_pincode[index],
                  location: multiDrop.set_unloading_address[index],
                  type: "Destination",
                });
              }
            });
            saveMastersApi(company_id, "location", temp_location_details, TrackMixPanel)
              .then((res) => {
                // toast.success('Details added in company profile')
              })
              .catch((err) => console.log(err));
          }
        })
        .catch((e) => console.log(e));
    } else {
      // if(send_data && send_data.length > 0){
      //     send_data.map(lanes =>{
      //         delete(lanes.savecompanyprofile)
      //     })
      // }
      delete item.savecompanyprofile;
    }
  };

  /**
   * Handles the deletion of an unloading address from the multidrop list.
   *
   * @param {number} index - The index of the unloading address to be deleted.
   */
  const deleteHandler = (index) => {
    if (multiDrop.unloading_address.length > 1) {
      const updatedUnloadingAddresses = multiDrop.unloading_address.filter(
        (value, i) => i !== index
      );
      const updatedCode = multiDrop.unloading_location_code.filter(
        (value, i) => i !== index
      );
      const updatedGst = multiDrop.unloading_gst_no.filter(
        (value, i) => i !== index
      );
      const updatedCustomer = multiDrop.unloading_customer_name.filter(
        (value, i) => i !== index
      );
      const updatedpinCode = multiDrop.unloading_pincode.filter(
        (value, i) => i !== index
      );
      const updatedLocation = multiDrop.unloading_location.filter(
        (value, i) => i !== index
      );

      setMultiDrop({ unloading_address: updatedUnloadingAddresses });
      setMultiDrop({ unloading_location_code: updatedCode });
      setMultiDrop({ unloading_gst_no: updatedGst });
      setMultiDrop({ unloading_customer_name: updatedCustomer });
      setMultiDrop({ unloading_pincode: updatedpinCode });
      setMultiDrop({ unloading_location: updatedLocation });
      setNoofdestination(noofdestination - 1);
    }
  };

  /**
   * Handles changes in the multidrop fields based on the input type.
   *
   * @param {Object} e - The event object.
   * @param {number} index - The index of the field being changed.
   * @param {string} type - The type of field being changed (e.g., 'location', 'address', 'gst').
   */
  const changehandlermultidrop = (e, index, type) => {
    switch (type) {
      case "location":
        var temp = multiDrop.unloading_location_code.slice();
        temp[index] = e.target.value;
        setMultiDrop({ unloading_location_code: temp });
        break;
      case "set_location_address":
        var temp = multiDrop.set_unloading_address.slice();
        temp[index] = e;
        setMultiDrop({ set_unloading_address: temp });
        break;
      case "address":
        var temp = multiDrop.unloading_address.slice();
        temp[index] = e.target.value;
        setMultiDrop({ unloading_address: temp });
        break;
      case "gst":
        var temp = multiDrop.unloading_gst_no.slice();
        temp[index] = e.target.value;
        setMultiDrop({ unloading_gst_no: temp });
        break;
      case "customer":
        var temp = multiDrop.unloading_customer_name.slice();
        temp[index] = e.target.value;
        setMultiDrop({ unloading_customer_name: temp });
        break;
      case "pincode":
        var temp = multiDrop.unloading_pincode.slice();
        temp[index] = e.target.value;
        setMultiDrop({ unloading_pincode: temp });
        break;
      case "location_address":
        var temp = multiDrop.unloading_location.slice();
        temp[index] = e;
        setMultiDrop({ unloading_location: temp });
        break;
      default:
        break;
    }
  };

  /**
   * Handles changes in the oneway fields based on the input type.
   *
   * @param {Object} e - The event object.
   * @param {number} index - The index of the field being changed.
   * @param {string} type - The type of field being changed (e.g., 'location', 'address', 'gst').
   */
  const changehandlerOneway = (e, index, type) => {
    switch (type) {
      case "location":
        var temp = oneWay.unloading_location_code.slice();
        temp[index] = e.target.value;
        setOneWay({ unloading_location_code: temp });
        break;
      case "address":
        var temp = oneWay.unloading_address.slice();
        temp[index] = e.target.value;
        setOneWay({ unloading_address: temp });
        break;
      case "gst":
        var temp = oneWay.unloading_gst_no.slice();
        temp[index] = e.target.value;
        setOneWay({ unloading_gst_no: temp });
        break;
      case "customer":
        var temp = oneWay.unloading_customer_name.slice();
        temp[index] = e.target.value;
        setOneWay({ unloading_customer_name: temp });
        break;
      case "pincode":
        var temp = oneWay.unloading_pincode.slice();
        temp[index] = e.target.value;
        setOneWay({ unloading_pincode: temp });
        break;
    }
  };

  /**
   * Handles changes in the roundtrip fields based on the input type.
   *
   * @param {Object} e - The event object.
   * @param {number} index - The index of the field being changed.
   * @param {string} type - The type of field being changed (e.g., 'location', 'address', 'gst').
   */
  const changehandlerRoundway = (e, index, type) => {
    switch (type) {
      case "location":
        var temp = roundWay.unloading_location_code.slice();
        temp[index] = e.target.value;
        setRoundWay({ unloading_location_code: temp });
        break;
      case "address":
        var temp = roundWay.unloading_address.slice();
        temp[index] = e.target.value;
        setRoundWay({ unloading_address: temp });
        break;
      case "gst":
        var temp = roundWay.unloading_gst_no.slice();
        temp[index] = e.target.value;
        setRoundWay({ unloading_gst_no: temp });
        break;
      case "customer":
        var temp = roundWay.unloading_customer_name.slice();
        temp[index] = e.target.value;
        setRoundWay({ unloading_customer_name: temp });
        break;
      case "pincode":
        var temp = roundWay.unloading_pincode.slice();
        temp[index] = e.target.value;
        setRoundWay({ unloading_pincode: temp });
        break;
    }
  };

  /**
   * Handles changes in the company profile checkbox.
   *
   * @param {Object} e - The event object.
   * @param {boolean} e.target.checked - The checked state of the checkbox.
   */
  const companyProfileChange = (e) => {
    var isChecked = e.target.checked;
    if (isChecked) {
      setCompany_profile(isChecked);
    } else {
      setCompany_profile(false);
    }
  };

  return (
    <div>
      {editmode ? (
        <div>
          <b>Note:</b>
          <span>Data will be only added if you click on submit button</span>
        </div>
      ) : null}
      {editmode ? (
        <div className="row">
          <div className="col-md-8">
            <div
              className="btn-group"
              role="group"
              style={{ justifyContent: "center" }}
            >
              <button
                type="button"
                id="oneway"
                className={`btn btn-default`}
                style={{
                  background: drop === "oneway" ? "#e0e0e0" : "#fff",
                  color: `${drop === "oneway" ? "#54af3a" : "#393185"}`,
                }}
                onClick={(e) => {
                  setDrop("oneway");
                }}
              >
                One-way
              </button>
              <button
                type="button"
                className={`btn btn-default`}
                style={{
                  background: drop === "roundtrip" ? "#e0e0e0" : "#fff",
                  color: `${drop === "roundtrip" ? "#54af3a" : "#393185"}`,
                }}
                onClick={(e) => {
                  setDrop("roundtrip");
                }}
              >
                Round Trip
              </button>
              <button
                type="button"
                className={`btn btn-default`}
                style={{
                  background: drop === "multidrop" ? "#e0e0e0" : "#fff",
                  color: `${drop === "multidrop" ? "#54af3a" : "#393185"}`,
                }}
                onClick={(e) => {
                  setDrop("multidrop");
                }}
              >
                Multi Drop
              </button>
            </div>
            <div className="pt-2">
              <span style={{ fontWeight: "bold" }}>Note:</span>
              <span className="pl-2">
                Loading and Unloading addresses are mandatory
              </span>
            </div>
          </div>
          <div
            className="col-md-4"
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "baseline",
            }}
          >
            <div>
              <input
                type="checkbox"
                id="companyprofile"
                checked={company_profile}
                style={{ width: "15px", height: "15px" }}
                onChange={(e) => companyProfileChange(e)}
              ></input>
            </div>
            <span
              for="company profile"
              style={{ paddingTop: "1.5%", paddingLeft: "2%" }}
            >
              Save in company profile
            </span>
          </div>
        </div>
      ) : (
        <div>
          <b>Drop: </b>
          <span>
            {item.drop
              ? item.drop === "roundtrip"
                ? "Round Trip"
                : item.drop === "multidrop"
                ? "Multi Drop"
                : "One Way"
              : "One Way"}
          </span>
        </div>
      )}
      <div
        style={{ maxHeight: "50vh", overflowX: "hidden", overflowY: "auto" }}
      >
        {editmode ? (
          <div className="row" style={{ width: "100%", margin: "1%" }}>
            <div className="col-md-12">
              <b>Loading Address: </b>
            </div>
            <div className="col-md-2 mt-1">
              <input
                placeholder="Enter location Code"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                }}
                rows="2"
                value={
                  drop === "multidrop"
                    ? multiDrop.loading_location_code
                    : drop === "oneway"
                    ? oneWay.loading_location_code
                    : drop === "roundtrip"
                    ? roundWay.loading_location_code
                    : ""
                }
                onChange={(e) =>
                  drop === "multidrop"
                    ? setMultiDrop({ loading_location_code: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ loading_location_code: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ loading_location_code: e.target.value })
                    : null
                }
              />
            </div>
            <div className="col-md-2">
              <input
                className="boldPlaceholder"
                placeholder="Enter Address *"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                }}
                rows="2"
                value={
                  drop === "multidrop"
                    ? multiDrop.loading_address
                    : drop === "oneway"
                    ? oneWay.loading_address
                    : drop === "roundtrip"
                    ? roundWay.loading_address
                    : ""
                }
                onChange={(e) =>
                  drop === "multidrop"
                    ? setMultiDrop({ loading_address: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ loading_address: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ loading_address: e.target.value })
                    : null
                }
              />
            </div>
            <div className="col-md-2">
              <input
                placeholder="Enter location"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                  cursor: "no-drop",
                }}
                // rows="2"
                value={item.origin.location_name}
                disabled={true}
              />
            </div>
            <div className="col-md-2">
              <input
                placeholder="Enter GST"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                }}
                rows="2"
                maxLength={15}
                value={
                  drop === "multidrop"
                    ? multiDrop.loading_gst_no
                    : drop === "oneway"
                    ? oneWay.loading_gst_no
                    : drop === "roundtrip"
                    ? roundWay.loading_gst_no
                    : ""
                }
                onChange={(e) =>
                  // console.log(e.target.value, "on loading gst ")
                  drop === "multidrop"
                    ? setMultiDrop({ loading_gst_no: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ loading_gst_no: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ loading_gst_no: e.target.value })
                    : null
                }
              />
            </div>
            <div className="col-md-2">
              <input
                placeholder="Enter Customer Name"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                }}
                rows="2"
                value={
                  drop === "multidrop"
                    ? multiDrop.loading_customer_name
                    : drop === "oneway"
                    ? oneWay.loading_customer_name
                    : drop === "roundtrip"
                    ? roundWay.loading_customer_name
                    : ""
                }
                onChange={(e) =>
                  drop === "multidrop"
                    ? setMultiDrop({ loading_customer_name: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ loading_customer_name: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ loading_customer_name: e.target.value })
                    : null
                }
              />
            </div>
            <div className="col-md-2">
              <input
                placeholder="Enter Pincode"
                style={{
                  fontSize: "13px",
                  padding: "5px",
                  minHeight: "auto",
                  margin: "1%",
                }}
                rows="2"
                value={
                  drop === "multidrop"
                    ? multiDrop.loading_pincode
                    : drop === "oneway"
                    ? oneWay.loading_pincode
                    : drop === "roundtrip"
                    ? roundWay.loading_pincode
                    : ""
                }
                onChange={(e) =>
                  drop === "multidrop"
                    ? setMultiDrop({ loading_pincode: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ loading_pincode: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ loading_pincode: e.target.value })
                    : null
                }
              />
            </div>
          </div>
        ) : (
          <div>
            <div>
              <b>Loading Address: </b>
              <span>{item.loading_address}</span>
            </div>
          </div>
        )}
        {editmode && drop === "multidrop" ? (
          <div className="row" style={{ width: "100%", margin: "1%" }}>
            <div className="col-md-2">
              <b>No of drops: </b>
            </div>
            <div className="col-md-8">
              {/* <button
                className="btn btn-sm btn-primary"
                style={{ padding: "3px 6px", borderRadius: "50%" }}
                onClick={(e) => {
                  if (multiDrop.unloading_address.length !== 1) {
                    var temp = [];
                    multiDrop.unloading_address.map((value, index) => {
                      if (index + 1 !== noofdestination) {
                        temp.push(value);
                      }
                    });
                    setMultiDrop({ unloading_address: temp });
                    setMultiDrop({ unloading_location_code: temp });
                    setMultiDrop({ unloading_gst_no: temp });
                    setMultiDrop({ unloading_customer_name: temp });
                    setMultiDrop({ unloading_pincode: temp });
                    setMultiDrop({ unloading_location: temp });
                  }
                  setNoofdestination(
                    noofdestination !== 1 ? noofdestination - 1 : 1
                  );
                }}
              >
                <i className="fa fa-minus" />
              </button> */}
              <button
                className="btn btn-sm btn-primary"
                style={{ padding: "3px 6px", borderRadius: "50%" }}
                onClick={() => {
                  if (multiDrop.unloading_address.length > 1) {
                    deleteHandler(noofdestination - 1);
                  }
                }}
              >
                <i className="fa fa-minus" />
              </button>
              <span
                style={{
                  padding: "0 10px",
                  margin: "0 5px",
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                }}
              >
                {noofdestination}
              </span>
              <button
                className="btn btn-sm btn-primary"
                style={{ padding: "3px 6px", borderRadius: "50%" }}
                onClick={(e) => {
                  // setUnloading_address([...unloading_address, ''])
                  setMultiDrop({
                    unloading_address: [...multiDrop.unloading_address, ""],
                  });
                  setMultiDrop({
                    unloading_location_code: [
                      ...multiDrop.unloading_location_code,
                      "",
                    ],
                  });
                  setMultiDrop({
                    unloading_gst_no: [...multiDrop.unloading_gst_no, ""],
                  });
                  setMultiDrop({
                    unloading_customer_name: [
                      ...multiDrop.unloading_customer_name,
                      "",
                    ],
                  });
                  setMultiDrop({
                    unloading_pincode: [...multiDrop.unloading_pincode, ""],
                  });
                  setMultiDrop({
                    unloading_location: [...multiDrop.unloading_location, ""],
                  });
                  setNoofdestination(noofdestination + 1);
                }}
              >
                <i className="fa fa-plus" />
              </button>
            </div>
          </div>
        ) : null}
        {editmode ? (
          <div className="row" style={{ width: "100%", margin: "1%" }}>
            <div className="col-md-12">
              <b>Unloading Address:</b>
            </div>
            {/* <div className={drop === 'multidrop' ? 'col-md-7' : 'col-md-8'}> */}
            {drop === "multidrop" && multiDrop.unloading_address.length > 0 ? (
              <>
                <div className="col-md-12 d-flex flex-grow-1 align-items-baseline">
                  <div className="d-flex flex-column">
                    {multiDrop.unloading_location_code.map((value, index) => (
                      <>
                        <div className="d-flex align-items-baseline">
                          {" "}
                          <div>{index + 1}.</div>
                          <div>
                            <input
                              placeholder="Enter location Code"
                              style={{
                                fontSize: "13px",
                                padding: "5px",
                                minHeight: "auto",
                                margin: "2%",
                              }}
                              rows="2"
                              value={value}
                              onChange={(e) =>
                                changehandlermultidrop(e, index, "location")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="d-flex flex-column">
                    {multiDrop.unloading_address.map((value, index) => (
                      <>
                        <div className="d-flex">
                          <input
                            className="boldPlaceholder"
                            placeholder="Enter Address *"
                            style={{
                              fontSize: "13px",
                              padding: "0px 2px",
                              minHeight: "auto",
                              margin:
                                (index ===
                                  multiDrop.unloading_address.length) ===
                                0
                                  ? "-1% 0% 1% 2%"
                                  : "1% 0% 1% 2%",
                            }}
                            rows="2"
                            value={multiDrop.unloading_address[index] || ""}
                            onChange={(e) =>changehandlermultidrop(e, index, "address")}
                          />
                          {/* <input 
                                placeholder='Enter location' 
                                style={{padding:'0px 2px', minHeight:'auto', margin: index === multiDrop.unloading_location.length === 0 ?'-1% 1% 1% 1%' : '1% 1% 1% 1%', cursor: index === multiDrop.unloading_location.length - 1 ? "no-drop" : "auto"}}
                                // rows="2"
                                // value={     
                                    // multiDrop.unloading_location[index]
                                    // drop === 'multidrop'? multiDrop.loading_location : 
                                    // drop === 'oneway'? oneWay.loading_location :
                                    // drop === 'roundtrip'? roundWay.loading_location :
                                    // "NA"
                                // }
                                value={index === multiDrop.unloading_location.length - 1 ? item.destination.location_name : multiDrop.unloading_location[index]}
                            //     onChange={e => drop=== 'multidrop'? setMultiDrop({ loading_location : e.target.value }) : 
                            //     drop=== 'oneway'?
                            //     setOneWay({ loading_location : e.target.value }):
                            //     drop=== 'roundtrip'?
                            //     setRoundWay({ loading_location : e.target.value }) :
                            //     null
                            // }
                            onChange={e => changehandlermultidrop(e, index, 'location_address')}
                            // disabled={true}
                            disabled={index === multiDrop.unloading_location.length - 1}
                    /> */}
                          <AutoComplete
                            placeholder="Enter location"
                            key={"Origin_Key"}
                            value={
                              index === multiDrop.unloading_location.length - 1
                                ? item.destination.location_name
                                : multiDrop.unloading_location[index] || ""
                            }
                            onChange={(e) =>
                              changehandlermultidrop(
                                e,
                                index,
                                "location_address"
                              )
                            }
                            disable={
                              index === multiDrop.unloading_location.length - 1
                                ? true
                                : false
                            }
                            onSelect={(e) =>
                              changehandlermultidrop(
                                e,
                                index,
                                "set_location_address"
                              )
                            }
                            // inputClassName={
                            //   index === multiDrop.unloading_location.length - 1
                            //     ? "destinationForMultidropDisable"
                            //     : "destinationForMultidrop"
                            // }
                            // user_identifier={localStorage.getItem(
                            //   "profile_company_id"
                            // )}
                            // module_key="indents"
                          />
                        </div>
                      </>
                    ))}
                  </div>

                  <div>
                    {multiDrop.unloading_gst_no.map((value, index) => (
                      <input
                        placeholder="Enter GST"
                        maxLength={15}
                        style={{
                          fontSize: "13px",
                          padding: "5px",
                          minHeight: "auto",
                          margin:
                            index === multiDrop.unloading_location.length - 1
                              ? "5.5% 1% 1% 0%"
                              : "3% 1% 1% 0%",
                        }}
                        rows="2"
                        value={value}
                        onChange={(e) =>
                          changehandlermultidrop(e, index, "gst")
                        }
                      />
                    ))}
                  </div>
                  <div>
                    {multiDrop.unloading_customer_name.map((value, index) => (
                      <input
                        placeholder="Enter Customer Name"
                        style={{
                          fontSize: "13px",
                          padding: "5px",
                          minHeight: "auto",
                          margin:
                            index === multiDrop.unloading_location.length - 1
                              ? "5.5% 1% 1% 1%"
                              : "3% 1% 1% 1%",
                        }}
                        rows="2"
                        value={value}
                        onChange={(e) =>
                          changehandlermultidrop(e, index, "customer")
                        }
                      />
                    ))}
                  </div>
                  <div className="d-flex flex-column">
                    {multiDrop.unloading_pincode.map((value, index) => (
                      <>
                        <div className="d-flex">
                          <input
                            placeholder="Enter Pincode"
                            style={{
                              fontSize: "13px",
                              padding: "5px",
                              minHeight: "auto",
                              margin:
                                index ===
                                multiDrop.unloading_location.length - 1
                                  ? "4% 1% 1% 2%"
                                  : "1.5% 1% 1% 2%",
                            }}
                            rows="2"
                            value={value}
                            onChange={(e) =>
                              changehandlermultidrop(e, index, "pincode")
                            }
                          />
                          <button
                            className={`btn btn-sm btn-primary h-75 mt-1 ${
                              index === multiDrop.unloading_location.length - 1
                                ? "mt-2"
                                : "mt-1"
                            }`}
                            onClick={() => deleteHandler(index)}
                          >
                            <i
                              className="fa fa-trash"
                              style={{ color: "white", cursor: "pointer" }}
                            ></i>
                          </button>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              </>
            ) : drop === "oneway" ? (
              <>
                <div className="col-md-2">
                  {oneWay.unloading_location_code.map((value, index) => (
                    <input
                      placeholder="Enter location Code"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "2%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerOneway(e, index, "location")
                      }
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {oneWay.unloading_address.map((value, index) => (
                    <input
                      className="boldPlaceholder"
                      placeholder="Enter Address *"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) => changehandlerOneway(e, index, "address")}
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  <input
                    placeholder="Enter location"
                    style={{
                      fontSize: "13px",
                      padding: "5px",
                      minHeight: "auto",
                      margin: "1%",
                      cursor: "no-drop",
                    }}
                    // rows="2"
                    value={item.destination.location_name}
                    disabled={true}
                  />
                </div>
                <div className="col-md-2">
                  {oneWay.unloading_gst_no.map((value, index) => (
                    <input
                      placeholder="Enter GST"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      maxLength={15}
                      value={value}
                      onChange={(e) => changehandlerOneway(e, index, "gst")}
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {oneWay.unloading_customer_name.map((value, index) => (
                    <input
                      placeholder="Enter Customer Name"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerOneway(e, index, "customer")
                      }
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {oneWay.unloading_pincode.map((value, index) => (
                    <input
                      placeholder="Enter Pincode"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) => changehandlerOneway(e, index, "pincode")}
                    />
                  ))}
                </div>
              </>
            ) : drop === "roundtrip" ? (
              <>
                <div className="col-md-2">
                  {roundWay.unloading_location_code.map((value, index) => (
                    <input
                      placeholder="Enter location Code"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "2%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerRoundway(e, index, "location")
                      }
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {roundWay.unloading_address.map((value, index) => (
                    <input
                      className="boldPlaceholder"
                      placeholder="Enter Address *"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerRoundway(e, index, "address")
                      }
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  <input
                    placeholder="Enter location"
                    style={{
                      fontSize: "13px",
                      padding: "5px",
                      minHeight: "auto",
                      margin: "1%",
                      cursor: "no-drop",
                    }}
                    // rows="2"
                    value={item.destination.location_name}
                    disabled={true}
                  />
                </div>
                <div className="col-md-2">
                  {roundWay.unloading_gst_no.map((value, index) => (
                    <input
                      placeholder="Enter GST"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      maxLength={15}
                      value={value}
                      onChange={(e) => changehandlerRoundway(e, index, "gst")}
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {roundWay.unloading_customer_name.map((value, index) => (
                    <input
                      placeholder="Enter Customer Name"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerRoundway(e, index, "customer")
                      }
                    />
                  ))}
                </div>
                <div className="col-md-2">
                  {roundWay.unloading_pincode.map((value, index) => (
                    <input
                      placeholder="Enter Pincode"
                      style={{
                        fontSize: "13px",
                        padding: "5px",
                        minHeight: "auto",
                        margin: "1%",
                      }}
                      rows="2"
                      value={value}
                      onChange={(e) =>
                        changehandlerRoundway(e, index, "pincode")
                      }
                    />
                  ))}
                </div>
              </>
            ) : // ))
            null}

            {/* </div> */}
          </div>
        ) : (
          <div>
            <div>
              <b>Unloading Address(es): </b>
            </div>
            <span>
              {drop === "multidrop" &&
              Array.isArray(multiDrop.unloading_address)
                ? multiDrop.unloading_address.map((value, index) => (
                    <>
                      <span>{index + 1}.</span>
                      <span className="pl-2">{value}</span>
                      <br />
                    </>
                  ))
                : drop === "oneway" && Array.isArray(oneWay.unloading_address)
                ? oneWay.unloading_address.map((value, index) => (
                    <>
                      <span>{value}</span>
                      <br />
                    </>
                  ))
                : drop === "roundtrip" &&
                  Array.isArray(roundWay.unloading_address)
                ? roundWay.unloading_address.map((value, index) => (
                    <>
                      <span>{value}</span>
                      <br />
                    </>
                  ))
                : ""}
            </span>
          </div>
        )}
        {editmode ? (
          <div className="row" style={{ width: "100%", margin: "1%" }}>
            <div className="col-md-2">
              <b>Additional Details:</b>
            </div>
            <div className="col-md-9">
              <textarea
                style={{ padding: "5px", minHeight: "auto", margin: "1%" }}
                rows="2"
                value={
                  drop === "multidrop"
                    ? multiDrop.additional_details
                    : drop === "oneway"
                    ? oneWay.additional_details
                    : drop === "roundtrip"
                    ? roundWay.additional_details
                    : ""
                }
                onChange={(e) =>
                  drop === "multidrop"
                    ? setMultiDrop({ additional_details: e.target.value })
                    : drop === "oneway"
                    ? setOneWay({ additional_details: e.target.value })
                    : drop === "roundtrip"
                    ? setRoundWay({ additional_details: e.target.value })
                    : ""
                }
              />
            </div>
          </div>
        ) : (
          <div>
            <div>
              <b>Additional Details: </b>
            </div>
            <span>{item.additional_details}</span>
          </div>
        )}
        {!planningbutton && !discovernowbutton && !backbutton ? (
          <div>
            <div>
              <b>Product Types: </b>
            </div>
            <div>
              <ul>
                {item.product_types && item.product_types.length > 0
                  ? item.product_types.map((productType, index) => (
                      <li key={index}>{productType.label}</li>
                    ))
                  : ""}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
      {newSpot===true || planningbutton|| discovernowbutton ||backbutton ? (
        <center>
          <button className="btn btn-sm btn-secondary" onClick={submitdata}>
            Submit
          </button>
        </center>
      ) : enquiryBucket==="active" ? <center>
          <button className="btn btn-sm btn-secondary" onClick={handleEditPlacementDetails}>
            Update
          </button>
        </center> : null}
    </div>
  );
};

export default PlacementDetails;
